(function (root, factory) {
  const api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  else root.MFBCommerce=api;
})(globalThis,function(){
  return {
    totalCents(priceCents,quantity,percent=0,enabled=false){
      if(!Number.isInteger(priceCents)||priceCents<0||!Number.isInteger(quantity)||quantity<0)throw new TypeError('Invalid price or quantity');
      if(!Number.isFinite(percent)||percent<0||percent>100)throw new RangeError('Invalid promotion');
      return Math.round(priceCents*quantity*(enabled?1-percent/100:1));
    },
    checkoutURL(shopUrl,variantId,quantity,promoCode=''){
      if(!/^\d+$/.test(String(variantId))||!Number.isInteger(quantity)||quantity<1)throw new TypeError('Invalid variant or quantity');
      const url=new URL('/cart/'+variantId+':'+quantity,shopUrl);
      if(url.protocol!=='https:')throw new TypeError('Checkout must use HTTPS');
      if(promoCode)url.searchParams.set('discount',promoCode);
      return url.href;
    }
  };
});
